import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { BRAND_VALUES, TIMELINE } from '../constants/content';

export default function AboutPage() {
  return (
    <>
      <PageHero
        title="关于 Ameowzing"
        subtitle="我们相信，冥想不是逃避现实，而是更好地与自己相处。Ameowzing 将专业冥想引导与现代 AI 技术相结合，陪伴你在忙碌生活中找到平静与力量。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '品牌故事' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-bold mb-4">品牌理念</h2>
          <p className="text-purple-200 leading-relaxed mb-4">
            Ameowzing 诞生于对正念生活与科技融合的探索。我们希望打破冥想「门槛高、难坚持」的刻板印象，
            让每一次练习成为与自我对话的温柔仪式。
          </p>
          <p className="text-purple-200 leading-relaxed">
            品牌名融合「Amazing」与「Meow」，寓意如猫咪般敏锐觉察与温暖陪伴。无论是 APP 内的 AI
            引导，还是线下的水果系列毛绒公仔，都在传递同一份信念：平静可以治愈，练习始于当下。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
          {BRAND_VALUES.map((item) => (
            <AnimatedCard
              key={item.title}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-purple-500/20 text-center"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-4">
                <i className={`fa ${item.icon} text-secondary text-2xl`} />
              </div>
              <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
              <p className="text-purple-200 text-sm">{item.desc}</p>
            </AnimatedCard>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-bold mb-6 text-center">我们的冥想观</h2>
          <div className="space-y-4">
            {[
              {
                title: '觉察，而非完美',
                text: '冥想的目标不是「什么都不想」，而是觉察当下的呼吸、身体与念头，温柔地与之共处。',
              },
              {
                title: '科学为基，AI 为翼',
                text: '练习基于正念与放松训练原理，AI 负责个性化推荐与陪伴，让坚持变得更简单。',
              },
              {
                title: '仪式感与日常陪伴',
                text: '引导音频、练习记录与萌趣周边共同构建冥想仪式感，让正念融入日常生活。',
              },
            ].map((item) => (
              <AnimatedCard
                key={item.title}
                className="bg-white/5 rounded-2xl p-6 border border-purple-500/20"
              >
                <h3 className="font-semibold text-secondary mb-2">{item.title}</h3>
                <p className="text-purple-200 text-sm leading-relaxed">{item.text}</p>
              </AnimatedCard>
            ))}
          </div>
        </div>

        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold mb-8 text-center">发展历程</h2>
          <div className="space-y-6">
            {TIMELINE.map((item) => (
              <AnimatedCard
                key={item.year}
                className="flex gap-6 bg-white/5 rounded-2xl p-6 border border-purple-500/20"
              >
                <span className="text-2xl font-bold text-gradient shrink-0">{item.year}</span>
                <p className="text-purple-200 text-sm leading-relaxed">{item.event}</p>
              </AnimatedCard>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <CTAButton to="/contact/business" variant="primary" icon="fa-handshake-o">
            商务合作咨询
          </CTAButton>
        </div>
      </section>
    </>
  );
}
